<!--
 * @Author: cyl
 * @Date: 2024-01-19 13:46:18
 * @LastEditors: cyl 
 * @LastEditTime: 2025-04-10 15:45:38
 * @Description: 魔方2.0-用户协议
-->
<template>
  <div style="padding: 10px 14px">
    <h3>User Agreement</h3>
    <p>
      Dear User, welcome to the services provided by Dongguan Andao Optoelectronic Materials Manufacturing Co., Ltd. This agreement is between you and Dongguan Andao
      Optoelectronic Materials Manufacturing Co., Ltd. regarding the use of Andao Teaching Magic Cube. "Andao" refers to the developer, operator, manager, and promoter of
      Andao Teaching Magic Cube (hereinafter referred to as "we"), while "User" refers to the user of Andao Teaching Magic Cube (hereinafter referred to as "you"). Before
      using the service, please read the following terms of service. By using this application, you agree to accept these terms of service, which have legal effect. In
      particular, clauses that exempt or limit Andao's liability, restrict user rights, protect privacy, govern accounts, apply laws, and resolve disputes, please read
      carefully and either accept or reject these terms of service. If you have any questions, please contact Andao.
    </p>
    <strong><p>1. Confirmation and acceptance of terms of service</p></strong>
    <p>By accessing or using the Application, you agree to accept all conditions and terms of this Agreement.</p>
    <strong><p>2. Changes and modifications to the Terms of Service</p></strong>
    <p>
      <strong>
        Considering the industry characteristics of frequent updates and iterations in internet services and products, we can make changes to the services provided at any
        time. Once changes occur to the service terms, they will be highlighted on important pages. We will inform you of these changes through various means, including but
        not limited to policy formulation, rules, explanations, agreements, and announcements. The updated agreement terms will replace the original ones and take effect upon
        expiration of the legal period. If you disagree with the changes, you may opt out of receiving the application's information services. By continuing to use the
        application's information services, you agree to the changes in the service terms.
      </strong>
    </p>
    <strong><p>3. User behavior</p></strong>
    <p>3.1 User account, password and security</p>
    <p>
      （1）You need to register an account to use the software product's features. You should log in and use it through your legally authorized mobile phone number or existing
      account. You are responsible for properly safeguarding your username and password information. If you discover that someone is using your account information without
      authorization or if you suspect that anyone may access your private content without permission, you should immediately change your password and notify our customer
      service team
    </p>
    <p>
      <strong>
        <u>
          （2） The account name, profile picture, and other registration information you submit must not contain any illegal or inappropriate content. If such issues are
          found after our review, we may refuse to register your account. Additionally, if it is discovered that you have registered with false information to obtain the Andao
          Teaching Magic Cube account name, or if there is any illegal or inappropriate content in your profile picture, description, or other registration information, we
          reserve the right to take measures such as requiring rectification within a specified period, suspending use, revoking registration, or reclaiming the account
          without notice.
        </u>
      </strong>
    </p>
    <p>
      <strong>
        You fully understand and agree that you must be responsible for all actions under your account, including any content you post and any consequences thereof. We have
        reason to believe that the actions of this account (including but not limited to feature settings and usage) are your actions when using the account, and the rights
        and obligations arising therefrom are borne by you personally. All actions taken under this account shall be based on our backend operation logs. If you fail to
        properly manage your account and password, causing losses to yourself, us, or third parties, you will bear full responsibility. You should make your own judgment
        regarding the content in this service and assume all risks associated with using this service and its content, including risks arising from reliance on the
        correctness, completeness, or practicality of this service and its content. Andao cannot and will not be liable for any loss or damage resulting from such risks.
      </strong>
    </p>
    <p>3.2 Prohibited behaviors during account registration</p>
    <p>（1）Do not register with the real name, nickname, art name or pen name of party and state leaders or other social celebrities;；</p>
    <p>（2）Impersonating any person or body, or falsely claiming or causing persons to believe that it is associated with any person or body in a false manner;</p>
    <p>（3）Do not register a name similar to that of other netizens;</p>
    <p>（4）Do not register names that are uncivilized or unhealthy, or contain words of discrimination, insult or indecency;</p>
    <p>（5）Do not register names that are ambiguous and cause misunderstanding;</p>
    <p>3.3 Users shall not publish the following illegal information and photos on this application:</p>
    <p>（1）Oppose the basic principles established by the Constitution;</p>
    <p>（2）endangering state security, divulging state secrets, subverting state power or undermining national unity;</p>
    <p>（3）damaging the honour and interests of the State;</p>
    <p>（4）inciting ethnic hatred or discrimination and undermining ethnic unity;</p>
    <p>（5）undermining the state's religious policies and promoting cults and feudal superstitions;</p>
    <p>（6）spreading rumors, disturbing social order and undermining social stability;</p>
    <p>（7）spreading obscenity, pornography, gambling, violence, murder, terror or inciting crimes;</p>
    <p>（8）insulting or defaming others or infringing upon their lawful rights and interests;</p>
    <p>
      （9）Other contents prohibited by laws, administrative regulations, judicial interpretations, local laws and regulations, local rules, departmental rules and other
      normative documents;
    </p>
    <p>（10）Prohibit harassment, defamation, threat, imitation of other websites;</p>
    <p>（11）It is strictly prohibited to incite illegal assemblies, associations, processions, demonstrations or mass disturbances of public order;</p>
    <p>
      （12）It is strictly prohibited to publish documents or information that may harm the rights and interests of third parties, such as (including but not limited to):
      virus code, hacker program, software cracking registration information.
    </p>
    <p>
      （13）Prohibit uploading works of others. This includes works downloaded, screenshots or collected from the Internet that may infringe on the legitimate rights and
      interests of others;
    </p>
    <p>（14）Prohibit uploading advertisements, banners, logos and other network pictures;</p>
    <p>（15）Violation of public order and good customs, social ethics, Andao platform rules or the legitimate rights and interests of other subjects.</p>
    <p>3.4 The user shall use the Software in accordance with:</p>
    <p>
      （1） You shall be solely responsible for the content (including but not limited to web pages, text, pictures, audio, video, charts, etc.) sent or disseminated through
      the Service;
    </p>
    <p>（2） The content you send or disseminate should have a legal source, and the relevant content is owned by you or you have obtained the necessary authorization.</p>
    <p>
      （3） You guarantee that you are responsible for the authenticity, legality and validity of the information, materials and evidence provided by you in the complaint
      handling procedure.
    </p>
    <p>
      3.5 We have the right to suspend, interrupt or terminate all or part of the account services provided by us to users under this Agreement in advance, based on the user's
      behavior and applicable rules, and possibly with the help of big data analysis, when we believe that it may be detrimental to our service provision or involve illegal
      activities, including but not limited to:
    </p>
    <p>（1）When the user is not the information subject who registered and logged in or the authorized person;</p>
    <p>（2）When abnormal conditions are found or there is reasonable reason to suspect that the operation is risky or illegal;</p>
    <p>（3）Other circumstances in which it is believed that the account has been used without authorization or is considered to be at risk;</p>
    <p>（4）user is deemed to have seriously violated the rules, norms, guidelines or user agreements set forth in this Agreement</p>
    <strong><p>4. Service content</p></strong>
    <p>
      4.1 The specific content of the Service is provided by us according to the actual situation, which can include the production and presentation of courseware based on the
      processing of materials, subject tools, mind maps, classroom activities, etc., as well as providing you with cloud storage of courseware, sharing of courseware and other
      functions.
    </p>
    <p>4.2 The software is a free application, and you will not be charged in any way or name during the use of the software.</p>
    <p>
      4.3
      <strong>
        <u>
          To better serve you, we will periodically provide updates or changes to this software and related services (including but not limited to software modifications,
          upgrades, partial deactivation of features, feature enhancements, development of new services, and software replacements). You can choose whether to update to the
          corresponding version based on your needs. We will notify you in an appropriate manner (including but not limited to system prompts, announcements, site messages,
          and app store update notifications) when feasible. You have the right to choose whether to accept the updated version; if you opt not to update, some functions of
          this software and related services may be restricted or unable to function properly.
        </u>
      </strong>
    </p>
    <p>
      4.4 This software may require you to have a compatible smart terminal and operating system; otherwise, it may affect the stability and compatibility of this software and
      service. The content and functions of this software may vary or change depending on the brand, model, and operating system of your smart terminal. Additionally, please
      obtain this software from our official website (http://www.amdolla.com.cn) or authorized third-party channels; otherwise, we cannot guarantee the security or
      compatibility of the software. Any losses you suffer as a result (such as file damage or loss) will not be our responsibility.
    </p>
    <p>
      4.5 If you are accidentally infringed upon by legitimate rights and interests or find that there are illegal activities or violations of the relevant rules of this
      Service during the use of this Software, you also have the right to report to us, and we will take necessary measures (such as deletion, blocking, disconnecting links or
      restricting functions) in time for disposal.
    </p>
    <p>4.6 You shall not engage in any of the following acts without the written permission of Andao:</p>
    <p>（1）Delete the information about copyright on the software and its copies;</p>
    <p>（2）Reverse engineering, reverse assembly, reverse compilation of the software, or otherwise attempt to discover the source code of the software;</p>
    <p>
      （3）Use, lease, lend, copy, modify, link, reprint, compile, publish, publish, establish mirror sites and other contents with intellectual property rights owned by
      Andao;
    </p>
    <p>
      （4）Replicate, modify, add to, delete, or attach and run any derivative works of the software or data released into any terminal memory during the operation of the
      software, interaction data between the client and server during the operation of the software, and system data required for the operation of the software; forms include,
      but are not limited to, using plugins, extensions, or third-party tools/services that have not been authorized by Andao to access the software and related systems;
    </p>
    <p>
      （5）Add, delete or change the functions or operation effects of the software by modifying or forging any instructions and data in the operation of the software, or
      operate or disseminate the software and methods used for the above purposes to the public, regardless of whether these acts are for commercial purposes;
    </p>
    <p>
      （6）Log in or use Andao software and services through any means such as third-party software, plug-ins, plug-ins, systems and equipment developed or authorized by
      Andao, or produce, publish and disseminate third-party software, plug-ins, plug-ins, systems and equipment developed or authorized by Andao for logging in or using Andao
      software and services.
    </p>
    <p>5.Third party relations and management</p>
    <p>
      When you use products or services provided by third parties on this Service, in addition to complying with the provisions of this Agreement, you shall also comply with
      the user agreements of third parties. Andao and third parties shall each bear their respective responsibilities for any disputes that may arise within the scope of legal
      provisions and agreements
    </p>
    <p>
      <strong>6.Ownership and intellectual property rights</strong>
    </p>
    <p>
      6.1
      <strong>
        <u>
          The ownership of the Andao Teaching Rubik's Cube account belongs to us, and we have the right to manage the account reasonably and provide account services according
          to this Agreement. As the applicant for registration, you enjoy the right to use the Andao Teaching Rubik's Cube account during the term of this Agreement.
        </u>
      </strong>
    </p>
    <p>
      6.2
      <strong>
        <u>
          The user understands and voluntarily commits that any form of information content (including but not limited to user reviews, user inquiries, various topic articles,
          etc.) published by you on this software will be voluntarily and irrevocably licensed to us and our affiliates for commercial use free of charge. Furthermore, you
          agree that we may sublicense these rights for reasonable purposes such as operations and promotion.
        </u>
      </strong>
    </p>
    <p>
      6.3 Any text, images, software, sounds, videos, recordings, pictures, music, and other content displayed by this software are owned by or legally authorized by Andao, or
      the rights holders have granted permission. Without separate written authorization from Andao and the relevant right holders, you may not reproduce, use, link to, or
      otherwise dispose of or utilize any part or all of these contents in any form, nor may you infringe upon the intellectual property rights or interests of the relevant
      right holders in any way.
    </p>
    <p>
      6.4 The copyright or trademark rights of the trademarks, service marks, business names, domain names, website names or other distinctive brand features
      ("Identifications") used by Andao in this Service, such as "Andao" and "Amdox", shall be owned by Andao.
    </p>
    <p>
      6.5 Competitive data rights obtained based on the legal processing of the data of this Software shall be independently used by us without your consent unless otherwise
      provided by laws and regulations.
    </p>
    <p>
      6.6 If you need to make commercial sales, copy and distribute, including but not limited to software sales, pre-installation, bundling, etc., you must obtain Andao's
      written use and license.
    </p>
    <p>
      6.7 The intellectual property rights of the above and any other content included in the Service are protected by laws and regulations. Without the written permission of
      Andao, users or relevant right holders, no one shall use or create related derivative works in any form.
    </p>
    <p>
      6.8 Reservations of Rights: All other rights not expressly used in this Agreement shall remain with Andao, and you must obtain Andao's written consent to use other
      rights.
    </p>
    <p>
      <strong>7. Privacy policy</strong>
    </p>
    <p>
      7.1 In order to provide you with more stable services and ensure the security of your transactions, we will collect and process your personal information according to
      this Agreement and the User Privacy Agreement. You can view and download the User Privacy Agreement.
    </p>
    <p>
      7.2 Teachers using this software should respect students 'privacy and personal information protection. If teachers violate this agreement or infringe on students'
      legitimate rights and interests such as privacy and personal information protection, teachers shall bear the corresponding responsibilities to students and their parents
      by themselves, and we shall not bear any responsibility.
    </p>
    <p>
      <strong>8. Legal liability and disclaimer</strong>
    </p>
    <p>
      8.1 If you violate relevant laws and regulations or the terms of this agreement while using this software, relevant government agencies or institutions may file
      lawsuits, impose fines, or take other punitive measures against you and request Andao to provide assistance. If any damage is caused to you or others as a result, you
      shall bear full responsibility, and Andao shall not be liable for any consequences.
    </p>
    <p>
      8.2 If you violate the terms of this agreement, Andao has the right to make independent judgments and take corresponding measures, including but not limited to removing,
      blocking relevant content or disconnecting links through technical means. At the same time, Andao has the right to take actions based on the nature of your behavior,
      including but not limited to suspending or terminating services provided to you, restricting, interrupting, freezing or terminating your use of the account, and pursuing
      legal responsibility.
    </p>
    <p>
      8.3 If you violate the provisions hereof and cause any claim, demand or loss of any third party, you shall bear the independent responsibility; if Andao suffers losses
      as a result, you shall also compensate for them.
    </p>
    <p>
      8.4 You agree and understand that Andao will make reasonable commercial efforts to ensure the security of your data storage in the Software Services, but Andao cannot
      provide a complete guarantee for this, as detailed in the Disclaimer.
    </p>
    <p>
      <strong>9.Modification and Termination of Agreement</strong>
    </p>
    <p>
      <strong>
        <u>
          If we discover, receive reports from others, or complaints about your violation of this agreement or laws and regulations, we have the right to independently make
          judgments and take actions such as warnings, freezing, terminating/ suspending/restricting account usage, deleting information content, suspending the use of
          licenses and/or services, terminating this agreement, and claiming damages (including but not limited to direct losses, indirect losses, reputational damage,
          third-party fines, claims, etc.). Any losses incurred by you as a result (including but not limited to content data, data clearance, etc.) shall be borne by you.
        </u>
      </strong>
    </p>
    <p>
      <strong>10.Law and Dispute Resolution</strong>
    </p>
    <p>10.1 This Agreement shall be governed by the laws of the People's Republic of China.</p>
    <p>
      10.2 Any dispute arising from or in connection with this Agreement shall be settled by the parties through friendly negotiation; if no agreement can be reached through
      negotiation, either party may submit the relevant dispute to the court where the registered office of Dongguan Andao Optoelectronic Materials Manufacturing Co., Ltd. is
      located.
    </p>
    <p><strong>11.Other</strong></p>
    <p>
      11.1 We remind you again that we have the right to modify the terms of this agreement at any time in response to changes in relevant laws and regulations, as well as
      adjustments to our business conditions and strategies. The revised service terms will be published on the software's webpage or client, APP operating platform. If you
      disagree with the modifications, you should cease using the related functions and technical services of the software. Continuing to use these functions and technical
      services will be deemed as your acceptance of the changes to the terms of this agreement.
    </p>
    <p>
      11.2 If any provision of this Agreement is wholly or partially invalid or unenforceable or contrary to any applicable law for any reason, such provision shall be deemed
      to have been deleted, provided that the remaining provisions of this Agreement shall remain valid and binding.
    </p>
    <p>
      11.3 Andao may assign all or part of its rights and obligations under this Agreement to other third parties. If you do not agree to Andao's assignment, you shall cease
      to use the Services under this Agreement. If you continue to use the Services, you shall be deemed to have accepted it
    </p>
    <p>
      At this point, the user has read and understood this Agreement in detail, and agrees to strictly abide by all the provisions of this Agreement. If you have any questions
      about this Agreement or wish to obtain any information from us, please contact the customer service personnel directly and effectively at the following address and
      method, and we will reply to you within 15 working days.
    </p>
    <p>Company: {{ activationCompany.company }}</p>
    <p>Tel: 400-632-8880</p>
    <p>Contact person: customer service specialist</p>
    <p>Address: {{ activationCompany.address }}</p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Andao Optoelectronic Materials Manufacturing Co., LTD',
        address: 'Building A, Building 11, Zone C, Songshan Lake International Finance Park, Dongguan City, Guangdong Province',
        abbreviation: 'Andao'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.primaryColor {
  color: #1e80ff;
}
</style>
